module.exports = __webpack_public_path__ + "static/prettylittlething-0b52014c6f6267b325d0b1ec820aa1a4.png";